import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M26.581 10.561c1.336 0 2.419 1.043 2.419 2.33v14.235c0 .483-.406.874-.907.874-.5 0-.907-.391-.907-.874v-2.582H4.814v2.582c0 .483-.406.874-.907.874-.5 0-.907-.391-.907-.874V12.892c0-1.287 1.083-2.33 2.419-2.33h.604V6.33C6.023 5.043 7.106 4 8.442 4h15.72c1.336 0 2.42 1.043 2.42 2.33v4.231Zm-19.046 8.53c0-.483.406-.874.907-.874h14.663c.5 0 .907.391.907.874 0 .482-.406.874-.907.874H8.442c-.5 0-.907-.392-.907-.874Z" clip-rule="evenodd" stroke="none"></path>';
export var LivingRoomSVG = function LivingRoomSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LivingRoomSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LivingRoomSVG);